import { useInView, useCounter } from '../hooks/useInView';
import { METRICS } from '../data';

function MetricCard({ metric, start }) {
  const value = useCounter(metric.val, 1700, start);
  return (
    <div className="bg-surf border border-bord rounded-2xl p-4 sm:p-5 border-t-[3px] transition-all duration-300 hover:-translate-y-1 cursor-default"
         style={{ borderTopColor: metric.color }}>
      <div className="font-display text-3xl font-extrabold leading-none mb-2 tabular-nums"
           style={{ color: metric.color }}>
        {value}{metric.suffix}
      </div>
      <div className="text-sm font-semibold text-tx mb-1">{metric.label}</div>
      <div className="text-[11px] text-tx3 leading-snug">{metric.desc}</div>
    </div>
  );
}

const PILLS = [
  { label: 'React.js',      color: 'text-cyan',  bg: 'bg-cyan/10',  border: 'border-cyan/22' },
  { label: 'Node.js',       color: 'text-grn',   bg: 'bg-grn/10',   border: 'border-grn/22' },
  { label: 'AWS Lambda',    color: 'text-aws',   bg: 'bg-aws/[.12]',border: 'border-aws/22' },
  { label: 'PostgreSQL',    color: 'text-pg',    bg: 'bg-pg/[.12]', border: 'border-pg/22' },
  { label: 'Python 🐍',    color: 'text-yel',   bg: 'bg-yel/10',   border: 'border-yel/22' },
  { label: 'React Native 📱',color:'text-cyan',  bg: 'bg-cyan/10',  border: 'border-cyan/22' },
  { label: 'AI / ML 🤖',   color: 'text-pur',   bg: 'bg-pur/10',   border: 'border-pur/22' },
  { label: 'Serverless',    color: 'text-aws2',  bg: 'bg-aws2/10',  border: 'border-aws2/22' },
];

export default function About() {
  const [ref, inView] = useInView(0.2);
  return (
    <section id="about" className="relative z-10 py-24 px-5 sm:px-8"
             style={{ background: 'linear-gradient(180deg,#080c14 0%,#0d1220 100%)' }}>
      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-14 items-start">
       
        <div>
          <span className="section-tag bg-pg/[.12] border border-pg/25 text-pg">{`// ABOUT`}</span>
          <h2 className="font-display font-extrabold tracking-tight leading-tight mb-6"
              style={{ fontSize: 'clamp(28px,4vw,46px)' }}>
            Building cloud-native <span className="text-aws">at scale.</span>
          </h2>
          <p className="text-tx2 text-sm leading-relaxed mb-3.5">
            Full Stack Developer at <strong className="text-tx">Excelsoft Technologies</strong> for 3.3 years — and currently
            freelancing on enterprise <strong className="text-aws">HRM</strong> and <strong className="text-cyan">CRM</strong> applications for clients.
          </p>
          <p className="text-tx2 text-sm leading-relaxed mb-3.5">
            Specialized in high-scale, event-driven distributed systems on AWS serverless. Proven track record improving DB stability,
            processing 500k+ records, and delivering real-time notifications at scale.
          </p>
          <p className="text-tx2 text-sm leading-relaxed mb-7">
            Currently deep-diving into <strong className="text-pg">Python + AI</strong> and <strong className="text-cyan">React Native</strong> — always building, always learning.
          </p>
          <div className="flex flex-wrap gap-2">
            {PILLS.map(p => (
              <span key={p.label}
                    className={`font-mono text-[10px] font-medium rounded-md px-2.5 py-1 border ${p.color} ${p.bg} ${p.border}`}>
                {p.label}
              </span>
            ))}
          </div>
        </div>
       
        <div ref={ref} className="grid grid-cols-2 gap-3.5">
          {METRICS.map((m, i) => <MetricCard key={i} metric={m} start={inView} />)}
        </div>
      </div>
    </section>
  );
}
